import React from 'react';
import './QouteBlock.module.scss';

type Props = {
  item: any;
};

export default function QuoteBlock({ item }: Props) {
  console.log(item, 'item');
  return (
    <div styleName="QuoteBlock">
      <h4>" {item.attributes.quote_block} "</h4>
    </div>
  );
}
